import React, { createContext, useState, useContext, useEffect, useCallback } from 'react'
import settings from '../../setting.json'
/**
 * Create ConfigContext
 * This context will manage the current configs internally and provide an easy interface
 */
export const ConfigContext = createContext()

/**
 * Custom provider to configs manager
 * This provider has a reducer for manage configs state
 * @param {props} props
 */
export const ConfigProvider = ({ children }) => {
  const [state, setState] = useState({ loading: true, configs: {} })
 
  const server = settings?.server

  const getSettings = useCallback(async () => {
    const endpoint = '/settings'
    try {
      setState(prev => ({ ...prev, loading: true }))
      const response = await fetch(server + endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const result = await response.json()
      if (!result.categoryTypeView || result.categoryTypeView === 'list') {
        result.categoryTypeView = 'grid'
      }
      const configs = { ...result, currency: 'KWD' }
      setState({ loading: false, configs })
      return configs
    } catch (err) {
      console.log(err, 'error')
      setState({ loading: false, configs: {} })
      throw err
    }
  }, [server])

  const refreshConfigs = useCallback(() => getSettings(), [getSettings])
 
  const functions = {
    refreshConfigs,
  }

  useEffect(() => {
    getSettings()
  }, [getSettings])

  return (
    <ConfigContext.Provider value={[state, functions]}>
      {children}
    </ConfigContext.Provider>
  )
}
/**
 * Hook to get and update configs state
 */
export const useConfig = () => {
  const configManager = useContext(ConfigContext)
  return configManager || [{}, async () => { }]
}